import { Component, Input } from '@angular/core';

@Component({
  selector: 'fgbcl-circle-progress-bar',
  templateUrl: './circle-progress-bar.component.html',
  styleUrl: './circle-progress-bar.component.scss',
})
export class CircleProgressBarComponent {
  @Input() value = 0;
  @Input() maxValue = 100;
  @Input() strokeTheme = `primary`;
  animatedProgress = 0;
  constructor() {}

  ngOnInit(): void {
    this.animateProgress();
  }

  animateProgress(): void {
    let startValue = 0;
    const endValue = (this.value / this.maxValue) * 100;
    const duration = 1000;
    const stepTime = Math.abs(Math.floor(duration / endValue));

    const timer = setInterval(() => {
      startValue++;
      this.animatedProgress = startValue;
      if (startValue >= endValue) {
        clearInterval(timer);
      }
    }, stepTime);
  }
}
